<template>
  <div id="Contact" class="contact">
    <h1 class="tit">Get in touch</h1>
    <p class="con">
      Widi Team is always here for you.
      Please share your thoughts with us.
    </p>
    <form class="form-post" method="post">
      <div class="sub-item">
        <label for="first-name">First Name</label>
        <el-input id="first-name" v-model="firstName"></el-input>
      </div>
      <div class="sub-item">
        <label for="last-name">Last Name</label>
        <el-input id="last-name" v-model="lastName"></el-input>
      </div>
      <div class="sub-item">
        <label for="phone">Phone Number</label>
        <div class="phone-container">
          <div class="area-container">
            <div class="area-container-show">
              <img v-show="areaImg" :src="areaImg" alt="">
              <span v-show="areaImg" :class="{'triangle-rotate':triangleIsRotate}" class="select-triangle"></span>
            </div>
            <el-select v-model="area_code" placeholder=" " v-loading="country_loading" @blur="triangleIsRotate=false" @change="changeArea">
              <el-option
                v-for="item in country_data"
                :key="item.id"
                :label="item.phone_prefix"
                :value="item.phone_prefix"
              >
                <span style="float: left">{{ item.phone_prefix }}</span>
                <div class="opt-img-box">
                  <img style="vertical-align: middle;" :src="item.flag" width="100" alt />
                </div>
              </el-option>
            </el-select>
          </div>
          <el-input id="phone" v-model="phoneNum"></el-input>
        </div>
      </div>
      <div class="sub-item">
        <label for="email">Email Address</label>
        <el-input id="email" v-model="email"></el-input>
      </div>
      <div class="sub-item message-item">
        <label for="message">Message</label>
        <textarea name="message" id="message" v-model="message"></textarea>
      </div>
    </form>
    <el-button
      @click="Contact"
      v-loading="btnLoading"
      element-loading-spinner="el-icon-loading"
      element-loading-custom-class="btn-loading"
      :disabled="btnLoading"
      class="sub-btn"
    >SEND MESSAGE</el-button>
  </div>
</template>

<script>
import { Contact } from "../api/register.js";
export default {
  props:{
    country_data:{
      type:Array
    },
    country_loading:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      firstName: "", //姓
      lastName: "", //名
      email: "", //电子邮箱
      phoneNum: "", //区号
      area_code: "+852", //手机区号
      message: "", //提交信息
      // countryData: JSON.parse(localStorage.getItem('country_data')),
      btnLoading: false,
      areaImg: null,
      triangleIsRotate: false
    };
  },
  methods: {
    changeArea(data) {
      this.triangleIsRotate = false
      this.areaImg = (this.country_data.find(item => item.phone_prefix === data)).flag
    },
    // 提交
    Contact() {
      // 非空验证
      if (
        this.firstName.trim().length === 0 ||
        this.lastName.trim().length === 0 ||
        this.email.trim().length === 0 ||
        this.phoneNum.trim().length === 0 ||
        this.message.trim().length === 0
      ) {
        this.$message.error("A required item is not filled in");
        return;
      }
      // 验证邮箱
      var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!regEmail.test(this.email)) {
        this.$message.error("Please check your email");
        return;
      }
      this.btnLoading = true;
      var data = {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        area_code: this.area_code,
        mobile: this.phoneNum,
        message: this.message
      };
      Contact(data)
        .then(res => {
          if (res.result === "success") {
            this.$message({
              message: "Submitted successfully",
              type: "success",
              customClass: "message"
            });
            this.$router.push({path: '/Home'})
          } else {
            this.$message.error("Failed to submit. Please try again later");
          }
          this.btnLoading = false;
        })
        .catch(err => {
          this.btnLoading = false;
          let msg = ''
          for (const key in err.response.data.error.errors) {
            msg += '<p style="line-height: 1.3;">' + err.response.data.error.errors[key] + '</p>'
          }
          this.$message({
            dangerouslyUseHTMLString: true,
            message: msg,
            type: 'error',
            duration: 5 * 1000
          })
        });
    }
  },
  created(){
    this.changeArea('+852')
  }
};
</script>

<style scoped lang="scss">
.contact {
  max-width: 780px;
  margin: 0 auto;
  text-align: center;
  .tit {
    font-size: 48px;
    padding: 4% 0;
  }
  .con {
    width: 55%;
    margin: 0 auto;
    font-size: 18px;
    color: rgba(35, 31, 32, 0.8);
  }
  .form-post {
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    width: 85%;
    margin: 40px auto 0;
    justify-content: space-between;
    .sub-item {
      width: 48%;
      margin-bottom: 10px;
      & > label {
        display: block;
        font-size: 14px;
        line-height: 50px;
      }
      .phone-container {
        position: relative;
        .area-container {
          position: absolute;
          left: 21px;
          top: 18px;
          z-index: 1;
          .area-container-show {
            display: flex;
            align-items: center;
            & > img {
              width: 25px;
              height: 13px;
            }
            .select-triangle {
              width: 0; 
              height: 0;
              border-width: 4px;
              border-style: solid;
              border-color: #111111 transparent transparent transparent;
              margin-left: 4px;
              transform-origin: center center;
              transition: ease-in-out 0.3s;
            }
            .triangle-rotate {
              transform: rotate(180deg);
            }
          }
        }
      }
      & > input,
      textarea {
        width: 100%;
        height: 50px;
        border: 1px solid rgba(189, 195, 199, 1);
        border-radius: 3px 3px 3px 3px;
        font-size: 18px;
        color: rgba(35, 31, 32, 0.6);
        outline: none;
        font-size: 16px;
      }
      & > textarea {
        text-indent: 0;
        padding: 15px;
        box-sizing: border-box;
      }
    }
    .message-item {
      width: 100%;
      & > input {
        height: 150px;
      }
      & > textarea {
        width: 100%;
        resize: none;
        height: 150px;
        color: #606266;
        font-family: "Regular";
      }
    }
  }
  .sub-btn {
    width: 220px;
    line-height: 50px;
    margin: 20px auto 120px;
    background: rgba(35, 189, 139, 1);
    font-size: 15px;
    color: white;
    padding: 0;
  }
  @media screen and (max-width: 768px) {
    .con {
      width: 75%;
    }
    .form-post {
      .sub-item {
        width: 100%;
      }
    }
    .sub-btn {
      margin-bottom: 0;
    }
  }
}
</style>

<style lang="scss">
#Contact {
  .phone-container {
    .area-container {
      .el-select {
        position: absolute;
        left: -20px;
        top: -18px;
        opacity: 0;
      }
    }
    .el-input__inner {
      text-indent: 50px;
    }
  }
}
.opt-img-box {
  float: right;
  img {
    width: 30px;
  }
}
</style>